<template>
  <div id="home-text" class="half-scherm bg-primary">
    <div id="text" class="text-white">
      <logoText />
      <div id="meerInfo" class=" pr-5 pt-5 text-right" @click="meerInfo_Clicked">
        <h3>
          Meer info<span id="pijltje"><img src="/images/arrow.svg" width="33px"/></span>
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import logoText from '@/components/LogoText.vue';

export default {
  name: 'tekst',

  components: { logoText },

  methods: {
    ...mapActions({
      updateLocation: 'pageLocation/updateLocation',
    }),

    meerInfo_Clicked() {
      this.updateLocation('info');
      this.$router.push('wiezijnwij');
    },
  },
};
</script>
